import pluralize from 'pluralize'
import { upperFirst, lowerFirst } from 'lodash'

import { DEFAULT_TRAINING_MATERIALS_TITLE } from '../../constants'

export class TrainingMaterialTitleFormatter {
  title = DEFAULT_TRAINING_MATERIALS_TITLE

  setTitle(title) {
    if (!title) {
      return
    }

    this.title = title
  }

  format(text) {
    const multipleTrainingMaterialsTitle = this.title
    const singleTrainingMaterialTitle = pluralize.singular(multipleTrainingMaterialsTitle)

    return text
      .replace(/\bTraining materials\b/g, upperFirst(multipleTrainingMaterialsTitle))
      .replace(/\btraining materials\b/g, lowerFirst(multipleTrainingMaterialsTitle))
      .replace(/\bTraining material\b/g, upperFirst(singleTrainingMaterialTitle))
      .replace(/\btraining material\b/g, lowerFirst(singleTrainingMaterialTitle))
  }
}

export const trainingMaterialTitleFormatter = new TrainingMaterialTitleFormatter()
